import Styles from './CategoryFilter.module.scss'
import { ChevronRight, ChevronLeft } from 'almanac-ui/icons/16'
import { useHover } from '@react-aria/interactions'
import cx from 'classnames'
import { ReactNode, useRef } from 'react'
import { useIntersectionObserver } from 'hooks/useIntersectionObserver'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useScrollIntoView } from 'hooks/useScrollIntoView'
import { IconButton } from 'blaze-ui/IconButton/IconButton'

interface CategoryFilterProps {
  children: ReactNode
  smallPadding?: boolean
}

export const CategoryFilterWrapper = ({ children, smallPadding }: CategoryFilterProps) => {
  const { hoverProps, isHovered } = useHover({})
  const { isMobile } = useResponsiveDesign()
  const { scrollIntoView } = useScrollIntoView()
  const rightScrollButtonRef = useRef<HTMLDivElement>(null)
  const leftScrollButtonRef = useRef<HTMLDivElement>(null)
  const isScrolledToLeft = useIntersectionObserver(leftScrollButtonRef, {
    threshold: 0.1,
  })?.isIntersecting
  const isScrolledToRight = useIntersectionObserver(rightScrollButtonRef, {
    threshold: 0.1,
  })?.isIntersecting

  return (
    <div className={cx(Styles.categoryFilter, { [Styles.smallPadding]: smallPadding })} {...hoverProps}>
      {!isMobile && (
        <div className={cx(Styles.scrollButton, Styles.left, { [Styles.visible]: isHovered && !isScrolledToLeft })}>
          <IconButton
            rounded
            icon={ChevronLeft}
            variant="secondary"
            size="sm"
            onPress={() => scrollIntoView(leftScrollButtonRef, { block: 'nearest' })}
          />
        </div>
      )}
      <div className={Styles.filtersList}>
        {!isMobile && <div ref={leftScrollButtonRef} data-testid="left-scroll-button" />}
        {children}
        {!isMobile && (
          <div className={Styles.scrollAnchor} ref={rightScrollButtonRef} data-testid="right-scroll-button" />
        )}
      </div>
      {!isMobile && (
        <div className={cx(Styles.scrollButton, { [Styles.visible]: isHovered && !isScrolledToRight })}>
          <IconButton
            rounded
            icon={ChevronRight}
            size="sm"
            variant="secondary"
            onPress={() => scrollIntoView(rightScrollButtonRef, { block: 'nearest' })}
          />
        </div>
      )}
    </div>
  )
}
